import {
  takeEvery,
  put,
  all,
  call,
  takeLeading,
  select,
} from 'redux-saga/effects';
import types from './actionTypes';
import * as shortLinksActions from './actions';
import { getFunctions, httpsCallable } from 'firebase/functions';
import rsf from '../../helpers/firebase';
import toastr from 'toastr';
import { toDateFirebase } from '../../helpers/sharedFunction';

const shortLinkTransformer = (shortLink, data) => ({
  id: shortLink.id,
  ...data,
  ...(data.lastClickAt && {
    lastClickAt: toDateFirebase(shortLink, data, 'lastClickAt').toDate(),
  }),
  ...(data.createdAt && {
    createdAt: toDateFirebase(shortLink, data).toDate(),
  }),
  ...(data.updatedAt && {
    updatedAt: toDateFirebase(shortLink, data, 'updatedAt').toDate(),
  }),
});

function* createShortLinkSaga({ shortLink }) {
  try {
    const companyId = yield select((state) => state.Dashboard.companyId);

    const functions = getFunctions();
    const createShortLinkFunction = httpsCallable(
      functions,
      'createShortLink-createShortLink',
    );
    const { data } = yield call(createShortLinkFunction, {
      ...shortLink,
      companyId,
    });

    if (data.error) throw new Error(data.error.message);

    yield put(shortLinksActions.createShortLinkSuccess());
    toastr.success(`Short link created: ${data.data.shortUrl}`, 'Success');
  } catch (error) {
    yield put(shortLinksActions.createShortLinkFailure(error));
    toastr.error(error.message, '');
  }
}

function* fetchShortLinksSaga({ startDate, endDate, filters }) {
  try {
    const companyId = yield select((state) => state.Dashboard.companyId);
    const shortLinksRef = rsf.firestore.createCollectionRefWithFilters(
      'shortLinks',
      companyId,
      startDate,
      endDate,
      filters,
    );

    const shortLinksSnap = yield call(
      rsf.firestore.getCollection,
      shortLinksRef,
    );

    let shortLinks = [];

    shortLinksSnap.forEach((shortLink) => {
      const data = shortLink.data();

      shortLinks.push(shortLinkTransformer(shortLink, data));
    });

    yield put(
      shortLinksActions.fetchShortLinksSuccess(
        shortLinks,
        startDate,
        endDate,
        filters,
      ),
    );
  } catch (error) {
    yield put(shortLinksActions.fetchShortLinksFailure(error));
  }
}

function* shortLinkSaga() {
  yield all([
    takeEvery(types.FETCH_SHORT_LINKS.REQUEST, fetchShortLinksSaga),
    takeLeading(types.CREATE_SHORT_LINK.REQUEST, createShortLinkSaga),
  ]);
}

export default shortLinkSaga;
